var Christmas = {};

//--------------
// Variables
//--------------

Christmas.bgEl = document.querySelector('.js-scroll-content'),
Christmas.defaultBgColor = Christmas.bgEl.style.backgroundColor,
Christmas.colortimeout,
Christmas.contentEl = document.querySelector('.js-scroll-content'),
Christmas.contents 	= Christmas.contentEl.querySelectorAll('.content__block'),
Christmas.backCtrl 	= Christmas.contentEl.querySelector('.btn-back'),
Christmas.contentNumber = Christmas.contentEl.querySelector('.content__number');

//--------------
// Snowing Methods
//--------------

Christmas.Snow = function() {
	this.canvas = document.createElement('canvas');
	this.canvas.id = 'snow';
	this.canvas.className = 'background';
	this.canvas.style.background = Christmas.defaultBgColor;
	this.canvas.style.position = 'fixed';
	$('.js-scroll-content').prepend(this.canvas);

	this.flakes = [];
	this.ctx = this.canvas.getContext('2d');
	this.flakeCount = 300;
	this.mX = -100,
	this.mY = -100

	this.width = this.canvas.width = $('.js-scroll-content').width();
	this.height = this.canvas.height = window.innerHeight;

	this._init();
}

Christmas.Snow.prototype._init = function() {
	var self = this;

	window.addEventListener('resize', function() {
		self.width = self.canvas.width = $('.js-scroll-content').width();
		self.height = self.canvas.height = window.innerHeight;
	});

	for(var i = 0; i < this.flakeCount; ++i) {
		var x = Math.floor(Math.random() * this.width),
			y = Math.floor(Math.random() * this.height),
			size = (Math.random()*3.5) + .5,
			speed = size*.5,
			opacity = (Math.random() * 0.5) + 0.1;

		this.flakes.push({
			speed: speed,
			velY: speed,
			velX: 0,
			x: x,
			y: y,
			size: size,
			stepSize: (Math.random()) / 30,
			step: 0,
			opacity: opacity
		});
	}

	this._snow();
};

Christmas.Snow.prototype._snow = function() {
	this.ctx.clearRect(0, 0, this.width, this.height);

	for(var i = 0; i < this.flakeCount; ++i) {
		var flake = this.flakes[i],
			x = this.mX,
			y = this.mY,
			minDist = 150,
			x2 = flake.x,
			y2 = flake.y,
			dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y)),
			dx = x2 - x,
			dy = y2 - y;

		if( dist < minDist ) {
			var force = minDist / (dist * dist),
			xcomp = (x - x2) / dist,
			ycomp = (y - y2) / dist,
			deltaV = force / 2;
			flake.velX -= deltaV * xcomp;
			flake.velY -= deltaV * ycomp;
		}
		else {
			flake.velX *= .98;
			if( flake.velY <= flake.speed ) {
				flake.velY = flake.speed
			}
			flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
		}

		this.ctx.fillStyle = "rgba(255,255,255," + flake.opacity + ")";
		flake.y += flake.velY;
		flake.x += flake.velX;

		if( flake.y >= this.height || flake.y <= 0 ) {
			this._reset(flake);
		}

		if( flake.x >= this.width || flake.x <= 0 ) {
			this._reset(flake);
		}

		this.ctx.beginPath();
		this.ctx.arc(flake.x, flake.y, flake.size, 0, Math.PI * 2);
		this.ctx.fill();
	}
	requestAnimationFrame(this._snow.bind(this));
};

Christmas.Snow.prototype._reset = function(flake) {
	flake.x = Math.floor(Math.random() * this.width);
	flake.y = 0;
	flake.size = (Math.random() * 3.5) + .5;
	flake.speed = flake.size*.5,
	flake.velY = flake.speed;
	flake.velX = 0;
	flake.opacity = (Math.random() * 0.5) + 0.1;
};


//--------------
// Start methods
//--------------

Christmas.init = function(){
	Christmas.snowing();

	setTimeout(function(){
		$.each($('.calendar_box'), function(){
			var index = parseInt($(this).find('.calendar_box__date').html());

			if($(this).hasClass('is-allowed')){
				$(this).find('.calendar_box__inner').css('display', 'block');
			}

			if(localStorage.getItem('movie_' + index)){
				$.getJSON("https://api.themoviedb.org/3/search/movie?api_key=fd0f6265831ee4c2c78d65d21334be1c&query="+Christmas.movies[index].title+"&callback=?", (json) => {
					$(this).find('.calendar_box__inner').attr('src', 'http://image.tmdb.org/t/p/w500/' + json.results[0].poster_path);
				});
				
				$(this).addClass('is-past');
			}
		});
	}, 200);

	$('.calendar_box.is-allowed').click(function(){
		$(this).addClass('is-opened');

		// Get movie
		var index = parseInt($(this).find('.calendar_box__date').html());
		var movie = Christmas.movies[index];
		
		$.getJSON("https://api.themoviedb.org/3/search/movie?api_key=fd0f6265831ee4c2c78d65d21334be1c&query="+movie.title+"&callback=?", (json) => {
			$(this).find('.calendar_box__inner').attr('src', 'http://image.tmdb.org/t/p/w500/' + json.results[0].poster_path);
		});

		localStorage.setItem('movie_' + index, true);
		
		setTimeout(() => {
			Christmas.fillPopup(movie, index);
		}, 800);
	});


	$('.calendar_box__inner').click(function(){
		// Get movie
		var index = parseInt($(this).closest('.calendar_box').find('.calendar_box__date').html());
		var movie = Christmas.movies[index];

		Christmas.fillPopup(movie, index);
	});


	$('body').on('click', '.js-christmas-popup .close', function(){
		$('.js-christmas-popup').fadeOut();
	});
}

Christmas.snowing = function(){
	Christmas.snow = new Christmas.Snow();
	Christmas.bgEl = Christmas.snow.canvas;
}


//--------------
// Games
//--------------

Christmas.fillPopup = function(movie, index){
	// Get image
	var json = $.getJSON("https://api.themoviedb.org/3/search/movie?api_key=15d2ea6d0dc1d476efbca3eba2b9bbfb&query="+movie.title);
	
	$.getJSON("https://api.themoviedb.org/3/search/movie?api_key=fd0f6265831ee4c2c78d65d21334be1c&query="+movie.title+"&callback=?", function(json) {
		$('.js-christmas-popup').find('.gift__image').prop('src', 'http://image.tmdb.org/t/p/w500/' + json.results[0].poster_path);
	});
	
	$('.js-christmas-popup').find('.gift__title').html(movie.title);
	$('.js-christmas-popup').find('.gift__description').html(movie.description);
	$('.js-christmas-popup').find('.gift__apple').attr('href', movie.apple);

	$('.js-christmas-popup').find('.gift__netflix_outer').hide();

	$('.js-christmas-popup').fadeIn();
}

//--------------
// Execution
//--------------

var POPUP_TPL = `
	<div class="christmas_popup js-christmas-popup">
		<a href="javascript:;" class="close popup-close"><span class="sr-only">Fermer</span></a>
		<div class="row">
			<div class="col-md-4 text-center text-md-left">
				<img class="gift__image img-fluid" src="">
			</div>
			<div class="col-md-8 gift__col-text">
				<p class="gift__title medium-title"></p>
				<p class="gift__description text color-grey-medium mb-20"></p>
				<p class="text color-grey-medium"> 
					<span class="gift__apple_outer"><a target="_blank" href="" class="gift__apple simple-link"><span>Regarder le film</span></a></span>
				</p>
			</div>
		</div>
	</div>
`;
$('body').append(POPUP_TPL);


Christmas.movies = {
	1: {
		title: "Noël à Candy Lane",
		description: "Après que Chris ait conclu par inadvertance un accord avec une malicieuse elfe nommée Pepper pour augmenter ses chances de gagner, celle-ci jette un sort magique qui donne vie aux 12 jours de Noël et provoque des ravages dans toute la ville. Au risque de gâcher les vacances de sa famille, Chris, sa femme Carol et leurs trois enfants doivent se lancer dans une course contre la montre pour briser le sort de Pepper, affronter des personnages magiques et diaboliques afin de sauver Noël pour tout le monde.",
		apple: "https://www.primevideo.com/-/nl/region/eu/detail/Candy-Cane-Lane/0HRQ67NQZWBZNAJCML7WX8VXYY",
	},
	2: {
		title: "Charlie et la Chocolaterie",
		description: "Charlie est un enfant issu d'une famille pauvre. Pour obtenir son comptant de sucreries, il participe à un concours organisé par l'inquiétant Willy Wonka, le propriétaire de la fabrique de chocolat de la ville. Celui qui découvrira l'un des cinq tickets d'or gagnera une vie de sucreries...",
		apple: "https://www.netflix.com/title/70021648"
	},
	3: {
		title: "Santa & Cie",
		description: "A l'approche du réveillon, tous les lutins en charge de fabriquer les cadeaux tombent malades. Désemparé face à la situation, le Père Noël décide de s'en rendre sur Terre pour trouver un remède. ",
		apple: "https://www.disneyplus.com/fr-fr/movies/santa-cie/20RhPpyTMiuL",
	},
	4: {
		title: "Gremlins",
		description: "Qu'il est étrange et émouvant le chant du Mogwaï le soir de Noël ! C'est le cadeau bizarre et intrigant que reçoit Billy. Trois règles sont à respecter: toujours garder le Mogwaï éloigné de l'eau, ne pas l'exposer à la lumière et surtout ne jamais le nourrir après minuit...",
		apple: "https://itunes.apple.com/fr/movie/gremlins/id601284107",
	},
	5: {
		title: "Joyeux Noël",
		description: "Lorsque la guerre surgit au creux de l'été 1914, elle surprend et emporte dans son tourbillon des millions d'hommes. Nikolaus Sprink, prodigieux ténor à l'opéra de Berlin, va devoir renoncer à sa belle carrière et surtout à celle qu'il aime : Anna Sörensen, soprane et partenaire de chant...",
		apple: "https://boutique.arte.tv/detail/joyeux-noel",
	},
	6: {
		title: "Christmas Office Party",
		description: "Carole, à la tête de l'entreprise familiale, menace de fermer la branche dirigée par son frère qui pense davantage à faire la fête qu'à faire des bénéfices. Pour conclure une vente qui pourra le sauver du licenciement, il se met à organiser une fête de Noël épique et hors-norme.",
		apple: "https://tv.apple.com/fr/movie/joyeux-bordel/umc.cmc.17xa6qqhw6vao402numh8gh15?action=play",
	},
	7: {
		title: "Super Noël",
		description: "La veille de Noël, un vendeur de jouets, Scott Calvin se retrouve dans une situation vraiment insolite : le Père Noël, ayant glissé du haut d’un toit, le désigne pour le remplacer. En enfilant les habits de ce Père Noël, Scott ignore tout de ce que cela implique et va vivre les aventures les plus cocasses...",
		apple: "https://www.disneyplus.com/fr-fr/movies/super-noel/3JPPheWC0SH5"
	},
	8: {
		title: "Hyper Nöel",
		description: "Scott Calvin (Tim Allen) est Père Noël depuis huit ans et tout le monde s’accorde à dire qu’il est de loin le meilleur. Pourtant tout risque de changer cette année ! Scott découvre en effet qu’il perdra son poste si son fils ne mérite plus de faire partie de la liste des enfants sages !",
		apple: "https://www.disneyplus.com/fr-fr/movies/hyper-noel/6wF7rjLypc61"
	},
	9: {
		title: "The Holidays",
		description: "Iris et Amanda sont deux femmes que tout oppose. L’une vit dans un confortable cottage anglais, l’autre dans une propriété huppée de Hollywood. Déçues par les hommes, elles décident de prendre l’air. Elles échangent alors sur Internet leurs maisons pour les vacances. Contre toute attente, chacune d’elles va rencontrer l’amour...",
		apple: "https://www.netflix.com/fr/title/70045854",
	},
	10: {
		title: "Le Pôle Express",
		description: "Lève toi vite et prépare toi pour le voyage de ta vie ! C'est la veille de Noël et tu vas bientôt escalader et descendre des montagnes à toute vitesse, glisser sur des lacs de glace, voler au dessus de ponts hauts de kilomètres, et te faire servir un chocolat chaud en chanson par des serveurs plus étonnants que jamais !",
		apple: "https://www.primevideo.com/-/fr/region/eu/detail/0HG3PJT68L1MJJDFUW3EMCB1XF/ref=atv_dp_amz_c_TS5124c5_1_2?language=fr&jic=16%7CCgNhbGwSA2FsbA%3D%3D"
	},
	11: {
		title: "La Reine des Neiges",
		description: "L'épopée de l'optimiste et courageuse Anna, en compagnie de Kristoff, un rude montagnard, et de Sven, son fidèle renne. Affrontant des conditions comparables à celles de l'Everest, ils partent à la recherche d'Elsa, la sœur d'Anna, dont les pouvoirs glaciaux ont figé le royaume d'Arendelle dans un hiver éternel.",
		apple: "https://www.disneyplus.com/fr-fr/movies/la-reine-des-neiges/4uKGzAJi3ROz"
	},
	12: {
		title: "Le drôle de Noël de Scrooge",
		description: "Ebenezer Scrooge commence les fêtes de Noël dans le mépris, mais trois fantômes l'emmènent faire un voyage révélateur. Il doit donc ouvrir son cœur pour se racheter de ses années de mauvaises actions.",
		apple: "https://www.disneyplus.com/fr-fr/movies/le-drole-de-noel-de-scrooge/QnakzyiFzOeP"
	},
	13: {
		title: "Edwards aux mains d’argent",
		description: "Il ne possède pas de vrais mains, mais des lames très tranchantes à la place des doigts. Il peut réaliser avec ses instruments de véritables oeuvres d'art, qui vont provoquer la curiosité et l'enthousiasme de toute la ville. Mais il est capable de blesser et de faire mal quand il ne se contrôle plus...",
		apple: "https://www.disneyplus.com/fr-fr/movies/edward-aux-mains-dargent/7IyLqt37708g",
	},
	14: {
		title: "La course aux jouets",
		description: "A la veille de Noël, Howard Langston doit accomplir une mission très particulière : trouver en 24 heures un TurboMan, un robot que son fils exige et que tout le monde s'arrache. Aux prises avec un postier un peu timbré et un faux Père Noël, Howard va devoir lutter pour obtenir le dernier TurboMan en circulation...",
		apple: "https://tv.apple.com/fr/movie/la-course-au-jouet/umc.cmc.329bisnjs2zqfs4a57oqqra9o?action=play",
	},
	15: {
		title: "Love Actually",
		description: "L'amour est partout, imprévisible, inexplicable, il frappe quand il veut et souvent, ça fait pas mal de dégâts! En cette veille de Noël à Londres, ces vies et ces amours vont se croiser, se frôler et se confronter, prouvant que la plus belle des choses peut engendrer les pires situations...",
		apple: "https://itunes.apple.com/fr/movie/love-actually/id874333575"
	},
	16: {
		title: "Esprit de famille",
		description: "Pendant les fêtes de fin d'année, Everett, le fils préféré des Stone, a décidé de venir accompagné de sa nouvelle petite amie, Meredith, carriériste new-yorkaise pur sucre. Le reste de la tribu fait tout de suite corps contre l'intruse.",
		apple: "https://itunes.apple.com/fr/movie/esprit-de-famille/id420142633"
	},
	17: {
		title: "Les Chroniques de Noël ",
		description: "Teddy et Kate Pierce prévoient de filmer le Père Noël le soir du réveillon. Après avoir attendu l’arrivée du Père Noël, ils se faufilent dans son traîneau et le cassent dans un accident, mettant ainsi Noël en péril. Ils vont aider ce Père Noël atypique, à sauver Noël avant qu'il ne soit trop tard.",
		apple: "https://www.netflix.com/title/80199682"
	},
	18: {
		title: "Miracle sur la 34ème rue",
		description: "La petite Susan n'a plus de papa; pour elle, c'est clair, le Père Noël n'existe pas. Aussi, lorsqu'il lui apparait, vêtu de son habit rouge, à bord de son traîneau, elle refuse d'y croire. Pour en avoir le coeur net, elle décide de le mettre au défi de réaliser un miracle : lui trouver un papa.",
		apple: "https://www.disneyplus.com/fr-fr/movies/miracle-sur-la-34eme-rue/nJfsTMhv4jTu"
	},
	19: {
		title: "Un jour sans fin",
		description: "Phil, un Monsieur Météo bien égoiste, se réveille à chaque fois le même jour. Il revit sans cesse la plus terrible journée de sa vie et peut déterminer les événements de la journée... jusqu'à la perfection! C’est Le Jour de la Marmotte! ...De nouveau..?",
		apple: "https://tv.apple.com/fr/movie/un-jour-sans-fin/umc.cmc.1w6jlmh7a3csaxq764zd0b6f0"
	},
	20: {
		title: "Le Grinch",
		description: "Prenez garde! Il est vert...Il est méchant...et il déteste Noël! Le grinch est une créature verte aux longs poils, grincheuse, qui vit en haut du Mont Crumpit. Alors que le 24 décembre approche, le grinch décide de gâcher Noël une bonne fois pour toutes et de voler cadeaux et décorations...",
		apple: "https://www.primevideo.com/-/fr/region/eu/detail/0SG81JCTV31IFXDE11822Z8RI3/ref=atv_sr_fle_c_Tn74RA_5_1_5?sr=1-5&language=fr&pageTypeIdSource=ASIN&pageTypeId=B0B8P86VLH&qid=1701425502219",
	},
	21: {
		title: "La princesse de Chicago",
		description: "En découvrant qu'elles se ressemblent comme deux gouttes d'eau, une pâtissière terre à terre et une future princesse élaborent un plan pour échanger leurs rôles.",
		apple: "https://www.netflix.com/fr/title/80242926"
	},
	22: {
		title: "La Belle et la Bête 2",
		description: "Belle demande aux objets enchantés du château de se joindre à elle pour organiser un Noël magique. Mais Belle, Big Ben, Lumiere et leurs amis pourront-ils déjouer les plans de Forte, le gigantesque orgue qui déteste tant les réjouissances et tente désespérément d’éloigner la Bête...",
		apple: "https://www.disneyplus.com/fr-fr/movies/la-belle-et-la-bete-2-le-noel-enchante/4OcpHSrxMFs0"
	},
	23: {
		title: "Beethoven sauve Noël",
		description: "Henri, jeune elfe, ne travaillera malheureusement pas dans l’atelier de jouets du Père Noël cette année. Déçu, il s’enfuit vers le Pôle Nord avec les jouets de Noël, mais son traîneau atterrit dans un arbre d’une banlieue américaine. La fête semble alors bien compromise...",
		apple: "https://itunes.apple.com/fr/movie/beethoven-sauve-no%C3%ABl/id477334900"
	},
	24: {
		title: "Maman j'ai raté l'avion",
		description: "La veille des vacances de Noël, la maison de Peter et Kate McCallister est en pleine effervescence. Ils doivent le lendemain, prendre l'avion afin de passer les fêtes à Paris. Au matin, dans l'affolement du départ. Peter et Kate oublient leur fils...",
		apple: "https://www.disneyplus.com/fr-fr/movies/maman-jai-rate-lavion/3v4vqKPG2jSr"
	},
	25: {
		title: "Mamain j'ai encore raté l'avion",
		description: "Après Paris, c'est à Miami que la tribu McCallister décide de passer les fêtes de Noël. A l'aube du jour J, toute la famille est sur le pied de guerre et file a l'aéroport en prenant bien garde de ne pas oublier Kevin. Mais ...",
		apple: "https://www.disneyplus.com/fr-fr/movies/maman-jai-encore-rate-lavion/3gjRdWD3Yks3"
	},
}

//--------------
// Export
//--------------

module.exports = Christmas;